import Box from '@mui/material/Box';
import {
  Carousel,
  useCarousel,
  CarouselThumb,
  CarouselThumbs,
  CarouselArrowNumberButtons,
} from 'src/components/carousel';
import { Image } from 'src/components/image';
import { RemoteImage } from '@/types';

// ----------------------------------------------------------------------

type Props = {
  images?: RemoteImage[];
};

export function GalleryCarousel({ images }: Props) {
  const carousel = useCarousel({ thumbs: { slidesToShow: 'auto' } });

  return (
    <div>
      <Box sx={{ mb: 2.5, position: 'relative' }}>
        <CarouselArrowNumberButtons
          {...carousel.arrows}
          options={carousel.options}
          totalSlides={carousel.dots.dotCount}
          selectedIndex={carousel.dots.selectedIndex + 1}
          sx={{ right: 16, bottom: 16, position: 'absolute' }}
        />

        <Carousel carousel={carousel} sx={{ borderRadius: 0 }}>
          {images?.map((slide: RemoteImage, index) => (
            <Image key={`CarouselThumb-${index}`} alt={slide.title} src={slide.url} ratio="1/1" />
          ))}
        </Carousel>
      </Box>

      <CarouselThumbs
        ref={carousel.thumbs.thumbsRef}
        options={carousel.options?.thumbs}
        slotProps={{ disableMask: true }}
        sx={{ width: 360 }}>
        {images?.map((item: RemoteImage, index: number) => (
          <CarouselThumb
            key={`CarouselThumb-${index}`}
            index={index}
            src={item.url}
            sx={{ borderRadius: 0 }}
            selected={index === carousel.thumbs.selectedIndex}
            onClick={() => carousel.thumbs.onClickThumb(index)}
          />
        ))}
      </CarouselThumbs>
    </div>
  );
}
